@if (loadingScreenService.loading$ | async) {
  <div class="loading-screen">
    <div class="logo">
      BPTF <span>&</span>L
      <span class="airplane">
        <mat-icon style="font-size: 40px;padding: 50px;">airplanemode_active</mat-icon>
      </span>
    </div>
    <div class="loading-text">
      Loading
      <span class="loading-dot">.</span>
      <span class="loading-dot">.</span>
      <span class="loading-dot">.</span>
    </div>
  </div>
}